import { useTranslation } from "react-i18next";

import type { UserCourseLesson } from "api/schemas/UserCourse";
import { LogoIcon } from "assets";
import { useProfileContext } from "contexts/ProfileContext";
import { Avatar } from "shared/atoms/Avatar";

import { LibraryItem } from "./LibraryItem";

export const LessonLibraryItem = ({
  item,
  checked,
  showAddButton,
  onClick,
}: {
  item: UserCourseLesson & { new?: boolean };
  checked: boolean;
  showAddButton?: boolean;
  onClick?: () => void;
}) => {
  const { t } = useTranslation();
  const { profile } = useProfileContext();
  const { creator_id, title } = item;
  const author = !creator_id
    ? undefined
    : {
        avatar: (
          <Avatar
            id={profile?.id}
            size={40}
            src={profile?.avatars?.medium || ""}
            name={`${profile?.first_name} ${profile?.last_name}`}
          />
        ),
        name: `${profile?.first_name} ${profile?.last_name}`,
      };
  const caption = item.parts_count ? `${item.parts_count} ${t("usercourse.parts")}` : undefined;
  const image = item.image_url ? (
    <img alt="" src={`${item.image_url}`} height="100%" />
  ) : (
    <LogoIcon title="Joint Academy" />
  );

  return (
    <LibraryItem
      author={author}
      caption={caption}
      checked={checked}
      id={item.id}
      image={image}
      isNew={item?.new}
      itemType="lesson"
      showAddButton={showAddButton}
      tags={item.target_joints}
      title={title}
      onClick={onClick}
    />
  );
};
